import Obfuscate from "react-obfuscate";

const bfecNum = "+65 6448 1800";

export const Phone = (props: { num?: string }) => (
  <Obfuscate tel={props.num ? props.num : bfecNum} />
);
